import axios from '../axios';

export const submitVideo = (data: BULLZ.SubmitVideoCurationRequest) =>
    axios<BULLZ.SubmitVideoCurationResponse>({
        url: '/curation/submit',
        data
    });
